const IndustryTypeConstants = {
  S_P_500_Index: "S & P 500 Index",
  China_Shanghai_SE_Composite: "China Shanghai SE Composite",
  Hong_Kong_Hang_Seng_Composite:"Hong Kong Hang Seng Composite"
};

export default IndustryTypeConstants;
